var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1739_25161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7387 0.248558C14.4138 -0.0763422 13.887 -0.0763422 13.5622 0.248558L7.49362 6.3171L1.42511 0.248558C1.10021 -0.0763422 0.57345 -0.0763422 0.248558 0.248558C-0.0763422 0.57345 -0.0763422 1.10021 0.248558 1.42511L6.31708 7.49364L0.248575 13.5621C-0.0763256 13.8871 -0.0763256 14.4138 0.248575 14.7387C0.573466 15.0636 1.10023 15.0636 1.42512 14.7387L7.49362 8.67018L13.5622 14.7387C13.887 15.0636 14.4138 15.0636 14.7387 14.7387C15.0636 14.4138 15.0636 13.8871 14.7387 13.5622L8.67015 7.49364L14.7387 1.42511C15.0636 1.10021 15.0636 0.57345 14.7387 0.248558Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1739_25161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseModal);
export default __webpack_public_path__ + "static/media/ic_close_modal.6ed6f93adaa8bcc0e7b90ae8202a7f7d.svg";
export { ForwardRef as ReactComponent };